import { makeEmbedHtml } from './youtube-utils';
import $ from 'jquery';

// Parse YouTube video id from a video url
// Nabbed from StackOverflow
const regex = /^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;

$(_ => {

  // When DOM's ready, look for ObjectTemplate-placed
  // anchors and replace them w/ iframe

  // <a class="js-yt-video-inserter" href="https://www.youtube.com/..."></a>
  $('a.js-yt-video-inserter').each(function() {
    const $el = $(this);
    const url = $el.attr('href');
    const matches = url.match(regex);
    let html = '';

    if (matches && matches.length === 2) {
      const videoId = matches[1];
      html = makeEmbedHtml(videoId);
    }

    $el.replaceWith(html);
  });

});